import { render, staticRenderFns } from "./Roblox.vue?vue&type=template&id=7c6d7ab0&scoped=true"
import script from "./Roblox.vue?vue&type=script&lang=js"
export * from "./Roblox.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Roblox.vue?vue&type=style&index=1&id=7c6d7ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d7ab0",
  null
  
)

export default component.exports